<div class="quiz-questions-wrapper"
     [@routeAnimations]="this.activeQuestionIndex || this.followUpAnswerIndex">
  <router-outlet></router-outlet>
</div>
